import { render, staticRenderFns } from "./PartnershipsMap.vue?vue&type=template&id=153cfeb4&scoped=true&"
import script from "./PartnershipsMap.vue?vue&type=script&setup=true&lang=js&"
export * from "./PartnershipsMap.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PartnershipsMap.vue?vue&type=style&index=0&id=153cfeb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153cfeb4",
  null
  
)

export default component.exports